export default __webpack_public_path__ + "9b449bdbc52082636b293b8705394d04.svg";